export const VideoBackdrop = ({ src, testid = "video-backdrop" }) => (
  <div className="pointer-events-none absolute inset-0 -z-10" data-testid={testid}>
    <video className="h-full w-full object-cover" src={`/media/${src}.mp4`} poster={`/media/${src}.jpg`} autoPlay muted loop playsInline preload="auto" aria-hidden="true" />
    <div className="absolute inset-0 bg-slate-950/45" />
    <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-slate-950/40 to-transparent" />
  </div>
);
